import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <p>Felix de Azara 730</p>
          <p>Corrientes, Argentina</p>
        </div>
        <div className="footer-section">
          <a href="mailto:info@humen.com.ar" className="footer-link">info@humen.com.ar</a>
        </div>
        <div className="footer-section">
          <p className="copyright">
            © {new Date().getFullYear()} Humen Inc.<br />
            Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 